export type GuestGuideKind = "inventory" | "appliance" | "unit";

const NUMBER_WORDS: Record<string, number> = {
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
  eleven: 11,
  twelve: 12,
};

/** Spoken count wins when the owner said a number; otherwise use the photo count. */
export function spokenNumberFromText(text: string | null | undefined): number | null {
  if (!text) return null;
  const raw = text.toLowerCase();
  const digit = raw.match(/\b(\d{1,3})\b/);
  if (digit) {
    const n = Number(digit[1]);
    return Number.isFinite(n) ? n : null;
  }
  for (const [word, n] of Object.entries(NUMBER_WORDS)) {
    if (new RegExp(`\\b${word}\\b`).test(raw)) return n;
  }
  return null;
}

export function isLinenName(name: string): boolean {
  const n = name.trim().toLowerCase();
  return /\b(sheet|sheets|linen|linens|bedding|duvet|comforter|pillowcase|pillowcases|fitted|flat sheet)\b/.test(
    n,
  );
}

/** "in the basket" if the phrase has no preposition; "on the shelf…" stays as typed. */
export function extrasWhere(place: string): string {
  // "The basket" must read "in the basket", never "in The basket".
  const p = place.trim().replace(/^([A-Z])(?=[a-z])/, (c) => c.toLowerCase());
  if (!p) return "";
  return /^(in|on|under|inside|at|by|next|behind|beside|above|below|near)\b/i.test(p) ? p : `in ${p}`;
}

export function guestSentence(input: {
  kind: GuestGuideKind;
  name: string;
  qty: number | null;
  place: string;
}): string {
  const name = input.name.trim() || "this";
  const lowered = name.toLowerCase();
  const place = input.place.trim();
  if (input.kind === "inventory") {
    const where = extrasWhere(place);
    const label = name.toLowerCase();
    return where ? `We leave extra ${label} ${where}.` : `We leave extra ${label}`;
  }
  if (!place) return `The ${lowered} is here.`;
  return `The ${lowered} is ${place.replace(/^([A-Z])(?=[a-z])/, (c) => c.toLowerCase())}.`;
}

/** Text-only Knowledge Hub body — never include photo URLs for guests. */
export function guestKnowledgeContent(copy: string, _placePhotoUrl?: string | null): string {
  return copy.trim();
}
